export default __webpack_public_path__ + "static/media/white_bishop.34a9f6e2.png";